export default "__VITE_ASSET__B6msLiKm__"